import { render, staticRenderFns } from "./LifeCare.vue?vue&type=template&id=3e04197a&scoped=true"
import script from "./LifeCare.vue?vue&type=script&lang=js"
export * from "./LifeCare.vue?vue&type=script&lang=js"
import style0 from "./LifeCare.vue?vue&type=style&index=0&id=3e04197a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e04197a",
  null
  
)

export default component.exports